/**
 * Checklist Template List Page
 *
 * Filter panel UI (search only). Filtering/pagination is handled
 * declaratively by HTMX. Delete confirmation is handled declaratively
 * via ``data-confirm-action="submit-form"`` (see
 * ``utils/ui/confirm-action.js``) — Phase 19 dropped the per-page
 * ``window.confirmDeleteTemplate`` wrapper.
 */

export function initChecklistTemplateList(options = {}) {
  const { hasActiveFilters = false } = options;
  initFilterPanelUI(hasActiveFilters);
  bindAfterSettleOnce();
}

function initFilterPanelUI(hasActiveFilters) {
  var panel = document.getElementById('filter-panel');
  var chevron = document.getElementById('filter-chevron');
  var toggleBtn = document.getElementById('toggle-filters-btn');
  var resetBtn = document.getElementById('reset-filters-btn');
  var clearSearchBtn = document.getElementById('clear-search-btn');
  var form = document.getElementById('templateFilterForm');
  var searchInput = document.getElementById('search-input');

  if (panel && hasActiveFilters) {
    panel.classList.remove('hidden');
    if (chevron) chevron.classList.add('rotate-180');
  }

  // Per-node idempotency via plain properties (not dataset) so the
  // flag does not serialize into HTMX hx-boost history snapshots.
  if (toggleBtn && panel && !toggleBtn._ctFilterBound) {
    toggleBtn._ctFilterBound = true;
    toggleBtn.addEventListener('click', function () {
      panel.classList.toggle('hidden');
      if (chevron) chevron.classList.toggle('rotate-180');
    });
  }

  if (resetBtn && form && !resetBtn._ctResetBound) {
    resetBtn._ctResetBound = true;
    resetBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      if (clearSearchBtn) clearSearchBtn.classList.add('hidden');
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (clearSearchBtn && searchInput && form && !clearSearchBtn._ctClearBound) {
    clearSearchBtn._ctClearBound = true;
    clearSearchBtn.addEventListener('click', function () {
      searchInput.value = '';
      clearSearchBtn.classList.add('hidden');
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (searchInput && clearSearchBtn && !searchInput._ctInputBound) {
    searchInput._ctInputBound = true;
    searchInput.addEventListener('input', function () {
      clearSearchBtn.classList.toggle('hidden', !searchInput.value.trim());
    });
  }
}

let afterSettleBound = false;

function bindAfterSettleOnce() {
  if (afterSettleBound) return;
  afterSettleBound = true;
  document.addEventListener('htmx:afterSettle', function (e) {
    var target = e.detail && e.detail.target;
    if (!target || target.id !== 'list-results') return;
    if (typeof window.reinitFlowbiteWidgets === 'function') {
      window.reinitFlowbiteWidgets(target);
    }
  });
}

/**
 * Auto-init entry point (wired via ``data-auto-init="checklistTemplateList"``).
 */
export function autoInitChecklistTemplateList() {
  const root = document.querySelector('[data-auto-init="checklistTemplateList"]');
  if (!root) return;
  initChecklistTemplateList({
    hasActiveFilters: root.dataset.hasActiveFilters === '1',
  });
}

window.initChecklistTemplateList = initChecklistTemplateList;
